import React, { useState } from 'react';
import { PlayCircleIcon, SearchIcon, ClockIcon, EyeIcon, BookmarkIcon, HeadphonesIcon, FileTextIcon, DownloadIcon, StarIcon } from 'lucide-react';
const videos = [{
  id: 1,
  title: 'Objection Handling Masterclass',
  instructor: 'Carlos Mendez',
  duration: '32:10',
  views: 389,
  thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=225&fit=crop',
  category: 'Objections'
}, {
  id: 2,
  title: 'FHA Loan Products Deep Dive',
  instructor: 'Mark Chen',
  duration: '28:15',
  views: 423,
  thumbnail: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=225&fit=crop',
  category: 'Training'
}, {
  id: 3,
  title: 'Cold Call Framework That Works',
  instructor: 'Sarah Kim',
  duration: '18:45',
  views: 847,
  thumbnail: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=225&fit=crop',
  category: 'Training'
}, {
  id: 4,
  title: 'Rate Lock Conversation Guide',
  instructor: 'Jennifer Walsh',
  duration: '22:30',
  views: 612,
  thumbnail: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=225&fit=crop',
  category: 'Training'
}, {
  id: 5,
  title: 'First-Time Homebuyer Presentation',
  instructor: 'Priya Rajan',
  duration: '15:00',
  views: 267,
  thumbnail: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=400&h=225&fit=crop',
  category: 'Purchase'
}, {
  id: 6,
  title: 'Refinance Pitch Perfect',
  instructor: 'Derek Liu',
  duration: '20:15',
  views: 198,
  thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=225&fit=crop',
  category: 'Refinance'
}];
const callClips = [{
  id: 1,
  title: 'Perfect Rate Objection Response',
  speaker: 'Sarah Kim',
  duration: '2:34',
  category: 'Objections',
  likes: 124,
  topRated: true
}, {
  id: 2,
  title: 'Closing the Hesitant Borrower',
  speaker: 'Carlos Mendez',
  duration: '3:12',
  category: 'Purchase',
  likes: 89,
  topRated: false
}, {
  id: 3,
  title: 'Pre-Approval Pitch',
  speaker: 'Priya Rajan',
  duration: '1:45',
  category: 'Purchase',
  likes: 67,
  topRated: false
}, {
  id: 4,
  title: "Handling 'I Need to Think About It'",
  speaker: 'Marcus Thompson',
  duration: '2:58',
  category: 'Objections',
  likes: 112,
  topRated: false
}, {
  id: 5,
  title: 'Referral Ask Script',
  speaker: 'Alex Chen',
  duration: '1:30',
  category: 'Referrals',
  likes: 94,
  topRated: false
}];
const scripts = [{
  id: 1,
  title: 'Initial Contact Script — Purchase',
  category: 'Purchase',
  preview: 'Hi [Name], this is [My Name] with Swift Home Loans. I saw you recently inquired about...'
}, {
  id: 2,
  title: 'Initial Contact Script — Refinance',
  category: 'Refinance',
  preview: "Hello [Name], I'm reaching out because rates have recently dropped in your area and..."
}, {
  id: 3,
  title: 'Rate Lock Conversation Guide',
  category: 'Training',
  preview: "When discussing rate locks, it's important to set expectations early. Start by explaining..."
}, {
  id: 4,
  title: 'Pre-Approval Follow-Up Sequence',
  category: 'Purchase',
  preview: 'Day 1: Email + Call. Day 3: Text message check-in. Day 7: Value-add email about...'
}, {
  id: 5,
  title: 'Realtor Partnership Pitch',
  category: 'Referrals',
  preview: "Hi [Realtor Name], I've been following your recent listings in [Area] and I'm impressed..."
}, {
  id: 6,
  title: 'Client Referral Request Script',
  category: 'Referrals',
  preview: "Congratulations on your clear to close! It's been a pleasure working with you. If you know..."
}];
const categories = ['All', 'Purchase', 'Refinance', 'Objections', 'Referrals', 'Training'];
export function SalesLibrary() {
  const [activeTab, setActiveTab] = useState<'videos' | 'clips' | 'scripts'>('videos');
  const [activeCategory, setActiveCategory] = useState('All');
  const [search, setSearch] = useState('');
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-674">
      {/* Header */}
      <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 24,
      flexWrap: 'wrap',
      gap: 12
    }} data-id="element-675">
        <div data-id="element-676">
          <h2 style={{
          fontSize: 26,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 3px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em'
        }} data-id="element-677">
            Sales Library
          </h2>
          <p style={{
          fontSize: 13,
          color: '#5A6A8A',
          margin: 0
        }} data-id="element-678">
            Videos, call clips, and scripts to help you close more loans
          </p>
        </div>
        <div style={{
        position: 'relative'
      }} data-id="element-679">
          <SearchIcon size={14} style={{
          position: 'absolute',
          left: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#A0AECB'
        }} data-id="element-680" />
          <input type="text" placeholder="Search resources..." value={search} onChange={e => setSearch(e.target.value)} style={{
          paddingLeft: 30,
          paddingRight: 12,
          paddingTop: 8,
          paddingBottom: 8,
          fontSize: 13,
          borderRadius: 8,
          border: '1.5px solid #E4EAF6',
          background: '#F4F8FC',
          color: '#1A2B3C',
          outline: 'none',
          width: 220
        }} onFocus={e => {
          e.target.style.borderColor = '#2B8DC4';
        }} onBlur={e => {
          e.target.style.borderColor = '#E4EAF6';
        }} data-id="element-681" />
        </div>
      </div>

      {/* Tabs & Filters */}
      <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 24,
      flexWrap: 'wrap',
      gap: 16
    }} data-id="element-682">
        <div style={{
        display: 'flex',
        gap: 4,
        padding: 4,
        borderRadius: 10,
        background: '#E4EAF6'
      }} data-id="element-683">
          {(['videos', 'clips', 'scripts'] as const).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} style={{
          padding: '8px 20px',
          borderRadius: 7,
          fontSize: 13,
          fontWeight: 800,
          fontStyle: 'italic',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.15s',
          textTransform: 'capitalize',
          background: activeTab === tab ? '#FFFFFF' : 'transparent',
          color: activeTab === tab ? '#1A2B3C' : '#5A6A8A',
          boxShadow: activeTab === tab ? '0 1px 4px rgba(13,27,42,0.1)' : 'none'
        }} data-id="element-684">
              {tab === 'videos' ? 'Videos' : tab === 'clips' ? 'Call Clips' : 'Sales Scripts'}
            </button>)}
        </div>

        <div style={{
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap'
      }} data-id="element-685">
          {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} style={{
          padding: '6px 14px',
          borderRadius: 6,
          fontSize: 12,
          fontWeight: 800,
          fontStyle: 'italic',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.15s',
          background: activeCategory === cat ? '#2B8DC4' : '#FFFFFF',
          color: activeCategory === cat ? '#FFFFFF' : '#5A6A8A',
          boxShadow: activeCategory === cat ? '0 2px 8px rgba(43,141,196,0.3)' : '0 1px 3px rgba(13,27,42,0.08)'
        }} data-id="element-686">
              {cat}
            </button>)}
        </div>
      </div>

      {/* Content Area */}
      {activeTab === 'videos' && <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 16
    }} data-id="element-687">
          {videos.filter(v => (activeCategory === 'All' || v.category === activeCategory) && v.title.toLowerCase().includes(search.toLowerCase())).map(video => <div key={video.id} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        overflow: 'hidden',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#2B8DC4',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
        transition: 'all 0.15s',
        cursor: 'pointer'
      }} onMouseEnter={e => {
        ;
        (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 16px rgba(43,141,196,0.12)';
        (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-2px)';
      }} onMouseLeave={e => {
        ;
        (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 8px rgba(13,27,42,0.06)';
        (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
      }} data-id="element-688">
                <div style={{
          position: 'relative',
          overflow: 'hidden',
          height: 160
        }} data-id="element-689">
                  <img src={video.thumbnail} alt={video.title} style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }} data-id="element-690" />
                  <div style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(13,27,42,0.35)'
          }} data-id="element-691" />
                  <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} data-id="element-692">
                    <div style={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.9)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} data-id="element-693">
                      <PlayCircleIcon size={22} color="#2B8DC4" data-id="element-694" />
                    </div>
                  </div>
                  <span style={{
            position: 'absolute',
            bottom: 8,
            right: 8,
            fontSize: 10,
            fontWeight: 700,
            padding: '2px 6px',
            borderRadius: 3,
            background: 'rgba(13,27,42,0.8)',
            color: 'white'
          }} data-id="element-695">
                    {video.duration}
                  </span>
                </div>
                <div style={{
          padding: '14px 16px'
        }} data-id="element-696">
                  <span style={{
            fontSize: 10,
            fontWeight: 800,
            padding: '2px 6px',
            borderRadius: 3,
            background: '#EBF5FB',
            color: '#2B8DC4',
            marginBottom: 6,
            display: 'inline-block'
          }} data-id="element-697">
                    {video.category}
                  </span>
                  <div style={{
            fontSize: 13,
            fontWeight: 800,
            color: '#1A2B3C',
            fontStyle: 'italic',
            letterSpacing: '-0.01em',
            lineHeight: 1.3,
            marginBottom: 8
          }} data-id="element-698">
                    {video.title}
                  </div>
                  <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }} data-id="element-699">
                    <span style={{
              fontSize: 11,
              color: '#A0AECB'
            }} data-id="element-700">
                      by {video.instructor}
                    </span>
                    <span style={{
              fontSize: 11,
              color: '#A0AECB',
              display: 'flex',
              alignItems: 'center',
              gap: 3
            }} data-id="element-701">
                      <EyeIcon size={11} data-id="element-702" /> {video.views}
                    </span>
                  </div>
                </div>
              </div>)}
        </div>}

      {activeTab === 'clips' && <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 16
    }} data-id="element-703">
          {callClips.filter(c => (activeCategory === 'All' || c.category === activeCategory) && c.title.toLowerCase().includes(search.toLowerCase())).map(clip => <div key={clip.id} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '16px 20px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#1A2B3C',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
        display: 'flex',
        alignItems: 'center',
        gap: 16
      }} data-id="element-704">
                <button style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: '#EBF5FB',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          flexShrink: 0,
          transition: 'all 0.15s'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#2B8DC4';
          e.currentTarget.style.color = 'white';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = '#EBF5FB';
          e.currentTarget.style.color = '#2B8DC4';
        }} data-id="element-705">
                  <PlayCircleIcon size={24} color="inherit" data-id="element-706" />
                </button>
                <div style={{
          flex: 1
        }} data-id="element-707">
                  <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 4
          }} data-id="element-708">
                    <span style={{
              fontSize: 10,
              fontWeight: 800,
              padding: '2px 6px',
              borderRadius: 3,
              background: '#F4F8FC',
              color: '#5A6A8A'
            }} data-id="element-709">
                      {clip.category}
                    </span>
                    {clip.topRated && <span style={{
              fontSize: 10,
              fontWeight: 800,
              padding: '2px 6px',
              borderRadius: 3,
              background: '#FFFBEB',
              color: '#D97706',
              display: 'flex',
              alignItems: 'center',
              gap: 3
            }} data-id="element-710">
                        <StarIcon size={10} fill="#D97706" data-id="element-711" /> Top Rated
                      </span>}
                  </div>
                  <div style={{
            fontSize: 14,
            fontWeight: 900,
            color: '#1A2B3C',
            fontStyle: 'italic',
            letterSpacing: '-0.01em',
            marginBottom: 4
          }} data-id="element-712">
                    {clip.title}
                  </div>
                  <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            fontSize: 11,
            color: '#A0AECB'
          }} data-id="element-713">
                    <span data-id="element-714">{clip.speaker}</span>
                    <span style={{
              display: 'flex',
              alignItems: 'center',
              gap: 4
            }} data-id="element-715">
                      <ClockIcon size={11} data-id="element-716" /> {clip.duration}
                    </span>
                  </div>
                </div>
              </div>)}
        </div>}

      {activeTab === 'scripts' && <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 16
    }} data-id="element-717">
          {scripts.filter(s => (activeCategory === 'All' || s.category === activeCategory) && s.title.toLowerCase().includes(search.toLowerCase())).map(script => <div key={script.id} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '20px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#2B8DC4',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
        display: 'flex',
        flexDirection: 'column'
      }} data-id="element-718">
                <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          marginBottom: 12
        }} data-id="element-719">
                  <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10
          }} data-id="element-720">
                    <div style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              background: '#EBF5FB',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} data-id="element-721">
                      <FileTextIcon size={18} color="#2B8DC4" data-id="element-722" />
                    </div>
                    <div data-id="element-723">
                      <div style={{
                fontSize: 14,
                fontWeight: 900,
                color: '#1A2B3C',
                fontStyle: 'italic',
                letterSpacing: '-0.01em'
              }} data-id="element-724">
                        {script.title}
                      </div>
                      <span style={{
                fontSize: 10,
                fontWeight: 800,
                padding: '1px 6px',
                borderRadius: 3,
                background: '#F4F8FC',
                color: '#5A6A8A',
                marginTop: 4,
                display: 'inline-block'
              }} data-id="element-725">
                        {script.category}
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{
          fontSize: 12,
          color: '#5A6A8A',
          lineHeight: 1.5,
          fontStyle: 'italic',
          background: '#F4F8FC',
          padding: '12px',
          borderRadius: 8,
          marginBottom: 16,
          flex: 1
        }} data-id="element-726">
                  "{script.preview}..."
                </div>
                <div style={{
          display: 'flex',
          gap: 12
        }} data-id="element-727">
                  <button style={{
            flex: 1,
            padding: '8px',
            borderRadius: 8,
            background: '#2B8DC4',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            fontSize: 12,
            fontWeight: 700,
            transition: 'background 0.15s'
          }} data-id="element-728">
                    View Full Script
                  </button>
                  <button style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            background: '#F4F8FC',
            border: '1px solid #E4EAF6',
            color: '#5A6A8A',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }} data-id="element-729">
                    <DownloadIcon size={16} data-id="element-730" />
                  </button>
                </div>
              </div>)}
        </div>}
    </div>;
}